import {Injectable} from "@angular/core";
import {BatteryHeaterMatType, DefaultService} from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BatteryHeaterMatService {
    constructor(private powerSupplyService: DefaultService) {
        this.getBatteryHeaterMatTypesService();
    }

    getBatteryHeaterMatTypesService() {
        return this.powerSupplyService.getBatteryHeaterMatTypes().pipe(map(res => res));
    }

    createBatteryHeaterMatType(model: BatteryHeaterMatType) {
        return this.powerSupplyService.createBatteryHeaterMatType(model).pipe(map(result => result));
    }

    updateBatteryHeaterMatType(model: BatteryHeaterMatType) {
        return this.powerSupplyService.updateBatteryHeaterMatType(model).pipe(map(result => result));
    }

    deleteBatteryHeaterMatType(id: number) {
        return this.powerSupplyService.deleteBatteryHeaterMatType(id).pipe(map(result => result));
    }
}
